import React from "react";
import './Home.css';
import AuthForm from "../login/AuthForm";
import HomeText from "./HomeText";


function Home() {
    return (
        <div className="home-page">
            <HomeText/>
            <AuthForm/>
        </div>
    )
}

export default Home;